module.exports = __webpack_public_path__ + "img/xtium_white_x_mark.b0e1a715.svg";